import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";

const ContactSuccess = () => {
  const data = useMemo(() => {
    const raw = window.sessionStorage.getItem("qz_contact_submission");
    try {
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  return (
    <section className="relative w-full overflow-hidden bg-[color:var(--navy)]">
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 h-[34rem] w-[34rem] rounded-full bg-[color:var(--brand-accent)]/22 blur-3xl" />
        <div className="absolute -bottom-52 -left-52 h-[38rem] w-[38rem] rounded-full bg-[color:var(--brand)]/26 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/25 to-black/45" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="mx-auto max-w-3xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white">
            Submitted
            <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
            Success
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-semibold tracking-tight text-white">
            Form has been successfully submitted
          </h1>

          <p className="mt-5 text-base sm:text-lg text-white/85">
            Thanks for reaching out. We’ll review your message and respond with a next step.
          </p>

          {data && (
            <div className="mt-10 rounded-2xl border border-white/15 bg-white/10 p-6 text-left backdrop-blur">
              <div className="text-sm font-semibold text-white/85">
                Submission summary
              </div>
              <div className="mt-4 grid gap-3 text-sm text-white/80">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="text-white/60">Name</span>
                  <span className="font-semibold text-white">
                    {data.firstName} {data.lastName}
                  </span>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="text-white/60">Email</span>
                  <span className="font-semibold text-white">
                    {data.email}
                  </span>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="text-white/60">Subject</span>
                  <span className="font-semibold text-white">{data.subject}</span>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="text-white/60">Your Message</span>
                  <span className="font-semibold text-white">
                    {data.message} 
                  </span>
                </div>
              </div>
            </div>
          )}

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <NavLink
              to="/"
              className="inline-flex items-center justify-center rounded-xl px-8 py-4 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95 transition shadow-lg"
            >
              Back to Home
            </NavLink>

            <NavLink
              to="/services"
              className="inline-flex items-center justify-center rounded-xl px-8 py-4 text-sm font-semibold bg-white/15 text-white hover:bg-white/25 transition"
            >
              View Services
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSuccess;
